import { TableHead, TableRow, TableCell, IconButton } from "@mui/material";
import moment from "moment";
import { toast } from "react-toastify";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { useGetCoupons, useDeleteCoupon, useChangeCouponStatus, CouponData, CouponFilter } from "./coupon";
import { IOSSwitch, MainTable, Pagination, SelectPopover, TableBody } from "../../atoms";
import { DeleteIcon, EditPencilIcon } from "../../icons";
import { useNotificationContext } from "../../contexts/notification";
import { useNavigate } from "react-router-dom";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
type ListViewProps = {
  filter: CouponFilter;
  handleFilter: (params: any) => void;
};
const ListView = ({ filter, handleFilter }: ListViewProps) => {
  const { isLoading: deleting, mutate: deleteCoupon } = useDeleteCoupon();
  const { isLoading: changingStatus, mutate: changeStatus } = useChangeCouponStatus();
  const { confirm } = useNotificationContext();
  const navigate = useNavigate();

  const { isFetching, data, refetch } = useGetCoupons(filter);
  const handleChangeStatus = (id: number) => {
    changeStatus(id, {
      onSuccess: () => {
        toast.success("Coupon status changed successfully.");
        refetch();
      },
    });
  };
  const handleDelete = (id: number) => {
    confirm({
      onConfirm: () => {
        deleteCoupon(id, {
          onSuccess: () => {
            toast.success("Coupon deleted successfully.");
            refetch();
          },
        });
      },
    });
  };
  return (
    <>
      <MainTable loading={isFetching || deleting || changingStatus}>
        <TableHead>
          <TableRow>
            <TableCell>Code</TableCell>
            <TableCell>Value</TableCell>
            <TableCell>Usage</TableCell>
            <TableCell>Start Date</TableCell>
            <TableCell>Expiry Date</TableCell>
            <TableCell>Actions</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data?.items.map((item) => (
            <TableRow key={item.id}>
              <TableCell sx={{ minWidth: "13%" }}>{item.code}</TableCell>
              <TableCell sx={{ minWidth: "15%" }}>
                {item.value}% {item.type}
              </TableCell>

              <TableCell>{item.totalUsage === 0 ? "Unlimited" : item.totalUsage}</TableCell>
              <TableCell>{moment(item.startDate).format("DD.MM.YYYY")}</TableCell>
              <TableCell>{moment(item.expiryDate).format("DD.MM.YYYY")}</TableCell>

              <TableCell>
                <IconButton onClick={() => handleChangeStatus(item.id)}>
                  <IOSSwitch checked={item.isActive} />
                </IconButton>

                <IconButton color="error" onClick={() => handleDelete(item.id)}>
                  <DeleteIcon />
                </IconButton>
                <SelectPopover
                  onChange={(index, value) => {
                    sessionStorage.setItem("COUPON_DATA", JSON.stringify(item));
                    if (index == 0) {
                      navigate(`${item.id}`);
                    } else if (index == 1) {
                      navigate(`${item.id}/edit`);
                    }
                  }}
                  options={[{ text: "View" }, { text: "Edit" }]}
                  render={(handleClick) => (
                    <IconButton onClick={handleClick}>
                      <MoreHorizIcon />
                    </IconButton>
                  )}
                />
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </MainTable>
      <div style={{ marginTop: "1.25rem" }}>
        <Pagination total={data?.total} onChange={(page) => handleFilter({ page })} />
      </div>
    </>
  );
};
export default ListView;
